import { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Grid,
    DialogTitle,
    styled,
    TableBody,
    TableContainer,
    TableCell,
} from '@mui/material';
import {
    setTableLogicName,
    setColumnLogicName
} from "../Common";

const ColorButton = styled(Button)({
    backgroundColor: "#00CC5B",
    color: "white",
    '&: hover':{
        backgroundColor: '#29e17a'
    }
});
const ErrorPageDataTablCell = styled(TableCell)({
    color: "red",
    border: "none",
    whiteSpace: "nowrap"
});
const ErrorDataTableCell = styled(TableCell)({
    color: "red",
    border: "none"
});

export interface InvalidInputListProps {
    props:{
        errorMessage: string,
        errorList: any,
        handleModalClose: () => void
    }
};

export const InvalidInputList:React.FC<InvalidInputListProps> = ({props}) => {

    return (
        <Box>
            <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                <DialogTitle>{props.errorMessage}</DialogTitle>
            </Grid>
            <Box sx={{ margin: "30px" }}>
                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                    <TableContainer  sx={{ height: "400px"}}>
                        {props.errorList?.map((data:any) => (
                            <TableBody key={"key_" + data.page + "__" + data.column + "__" + data.error}>
                                <ErrorPageDataTablCell>{setTableLogicName(data.page)}</ErrorPageDataTablCell>
                                {
                                    data.column === "" &&
                                        //通行量のデータ件数をチェックする場合は、テーブルの項目名がないためエラーメッセージを表示
                                        <ErrorDataTableCell colSpan={2}>{data.error}</ErrorDataTableCell>
                                }
                                {
                                    data.column !== "" &&
                                        <>
                                            {/* テーブル項目名とエラーメッセージを表示 */}
                                            <ErrorDataTableCell>{setColumnLogicName(data.page, data.column)}</ErrorDataTableCell>
                                            <ErrorDataTableCell>
                                                {/* エラーメッセージ内に<br>タグがあれば改行して表示 */}
                                                {data.error.includes('<br>') ? data.error.split('<br>').map((errorLine:any,index:number) => (<span key={index}>{errorLine}<br/></span>)) : data.error}
                                            </ErrorDataTableCell>
                                        </>
                                }
                            </TableBody>
                        ))}
                    </TableContainer>
                </Grid>
                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                    <ColorButton onClick={props.handleModalClose}>閉じる</ColorButton>
                </Grid>
            </Box>
        </Box>

    );
};


export default InvalidInputList;